// removed by extract-text-webpack-plugin
module.exports = {"overflow":"src-components-modules-ContentBlocks-ImageStats-style----general-module---overflow---UHEC9 bg-licorice breakPointM-bg-none overflow-hidden","container":"src-components-modules-ContentBlocks-ImageStats-style----general-module---container---1pc9V bg-licorice","item":"src-components-modules-ContentBlocks-ImageStats-style----general-module---item---C-m59 textAlign-left"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/ContentBlocks/ImageStats/style/general.module.css
// module id = 249
// module chunks = 3627797113349 20562973939449 33019919093843